<div
  class="card-number-container"
  fxLayout
  fxLayoutAlign="center center"
  [style.background-color]="section?.metadata?.productsHeaderBackgroundColor || '#000000'">
  <div class="card-number" [style.color]="automaticNumberTextColor$ | async">
    {{ cardNumber$ | async }}
  </div>
</div>
